"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FxCrossLegType = exports.FxCrossType = exports.Outputs = exports.PriceSide = exports.FxSwapCalculationMethod = exports.BuySell = void 0;
var financial_contracts_1 = require("./financial-contracts");
Object.defineProperty(exports, "BuySell", { enumerable: true, get: function () { return financial_contracts_1.BuySell; } });
Object.defineProperty(exports, "FxSwapCalculationMethod", { enumerable: true, get: function () { return financial_contracts_1.FxSwapCalculationMethod; } });
Object.defineProperty(exports, "PriceSide", { enumerable: true, get: function () { return financial_contracts_1.PriceSide; } });
Object.defineProperty(exports, "Outputs", { enumerable: true, get: function () { return financial_contracts_1.Outputs; } });
var FxCrossType;
(function (FxCrossType) {
    FxCrossType["FxSpot"] = "FxSpot";
    FxCrossType["FxForward"] = "FxForward";
    FxCrossType["FxNonDeliverableForward"] = "FxNonDeliverableForward";
    FxCrossType["FxSwap"] = "FxSwap";
    FxCrossType["FxForwardForward"] = "FxForwardForward";
})(FxCrossType || (exports.FxCrossType = FxCrossType = {}));
var FxCrossLegType;
(function (FxCrossLegType) {
    FxCrossLegType["FxSpot"] = "FxSpot";
    FxCrossLegType["FxForward"] = "FxForward";
    FxCrossLegType["FxNonDeliverableForward"] = "FxNonDeliverableForward";
    FxCrossLegType["SwapNear"] = "SwapNear";
    FxCrossLegType["SwapFar"] = "SwapFar";
})(FxCrossLegType || (exports.FxCrossLegType = FxCrossLegType = {}));
